import React, { Component } from 'react';
import {
  Paper, TextField, Button, Typography, Box,
} from '@mui/material';
import { connect, ConnectedProps } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { isValidEmail } from '../components/form/validation';

import {
  requestPasswordReset,
  showNotification,
  loggedOut,
} from '../redux/actions';
import withRouter, { RouteType } from '../hoc/withRouter';

type Props = ReduxProps & RouteType;
type State = {
  email: string;
  newPasswordRequested: boolean;
  errorMessage?: React.ReactNode;
};

class PasswordRequestView extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      email: '',
      newPasswordRequested: false,
    };
  }

  goToLogin = () => {
    const { router } = this.props;
    router.navigate('/login');
  };

  requestNewPassword = async () => {
    const {
      requestPasswordReset: requestPasswordResetAction,
    } = this.props;
    const { email } = this.state;
    try {
      const res = await requestPasswordResetAction(email.trim());
      if (res) {
        if (res.error) {
          this.setState({ errorMessage: <FormattedMessage id="resetPassword.emailError" /> });
        } else {
          this.setState({ newPasswordRequested: true });
        }
      }
    } catch (error) {
      this.setState({ errorMessage: <FormattedMessage id="resetPassword.emailError" /> });
    }
  };

  render() {
    const {
      errorMessage,
      newPasswordRequested,
    } = this.state;
    return (
      <Box
        sx={{
          padding: 0.5,
          display: 'flex',
          justifyContent: 'center',
          minWidth: '100vw',
        }}
      >
        <Paper
          sx={{
            width: 400,
            margin: '0 auto',
            padding: '15px',
          }}
          variant="outlined"
        >
          <Typography variant="h5">
            <FormattedMessage id="passwordRequest.heading" />
          </Typography>
          <TextField
            required
            type="text"
            label="E-Mail"
            onChange={(e) => {
              const { value } = e.target;
              if (!isValidEmail(value)) {
                this.setState({ errorMessage: <FormattedMessage id="registration.noValidMail" /> });
                return;
              }
              this.setState({ errorMessage: undefined });
              this.setState({ email: e.target.value });
            }}
            error={!!errorMessage}
            helperText={errorMessage}
            sx={{ width: '100%', my: 1 }}
            variant="outlined"
            size="small"
          />
          <Button
            variant="contained"
            onClick={this.requestNewPassword}
            sx={{
              color: 'white',
              width: '100%',
              backgroundColor: 'primary.main',
              my: 1,
            }}
            disabled={newPasswordRequested || !!errorMessage}
          >
            <FormattedMessage id="passwordRequest.buttonLabel" />
          </Button>
          {newPasswordRequested
            && (
              <Box>
                <Typography variant="body2" sx={{ my: 2 }}>
                  <FormattedMessage id="resetPassword.resetEmailSend" />
                </Typography>
                <Button
                  variant="contained"
                  onClick={this.goToLogin}
                >
                  <FormattedMessage id="passwordRequest.goToLogin" />
                </Button>
              </Box>
            )}
        </Paper>
      </Box>
    );
  }
}

const mapDispatchToProps = (dispatch: any) => ({
  requestPasswordReset: (email: string) => {
    dispatch(loggedOut());
    return dispatch(requestPasswordReset(email));
  },
  showNotification: (
    message: string | React.ReactElement<unknown, string | React.JSXElementConstructor<unknown>>,
  ) => dispatch(showNotification(message)),
});

const connector = connect(null, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;
export default connector(withRouter(PasswordRequestView));
